import { render, staticRenderFns } from "./remove-picked-lpn-new-ui.vue?vue&type=template&id=48710844&"
import script from "./js/remove-picked-lpn-new-ui.js?vue&type=script&lang=js&"
export * from "./js/remove-picked-lpn-new-ui.js?vue&type=script&lang=js&"
import style0 from "./remove-picked-lpn-new-ui.vue?vue&type=style&index=0&id=48710844&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports